import axios from './axios';

export const fetchNotifications = async ({ cursor, limit = 10 } = {}) => {
    const params = { limit };
    if (cursor) params.cursor = cursor;
    const response = await axios.get('/notifications', { params });
    return response.data;
};

export const fetchUnreadCount = async () => {
    const response = await axios.get('/notifications/unread-count');
    return response.data.count;
};

export const markNotificationsRead = async (notificationIDs) => {
    const response = await axios.put('/notifications/read', { notificationIDs });
    return response.data;
};

export const markAllNotificationsRead = async () => {
    const response = await axios.put('/notifications/read-all');
    return response.data;
};
